import Axios from "axios";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import { API_URL } from "../../../../../config";
import DocumentsCompacts from "../../../../common/CarteLead/DocumentsCompacts";
import { DOCUMENT_LABELS } from "../../../SimplifiedFormListPage/SimplifiedFormItem/LeadAttachedDocument/LeadAttachedDocument";
import { OCR_DOCUMENT_NAMES } from "../documentConstants";
import { compagnieDuDocument, libelleDevis } from "./libelleDocument";

// Types de documents graal sans libellé ailleurs.
const AUTRES_LIBELLES = { DEVIS_AUTO_PERCEVAL: "Devis auto Perceval" };

const libelleDuType = (type) =>
  OCR_DOCUMENT_NAMES[type] || DOCUMENT_LABELS[type] || AUTRES_LIBELLES[type] || type || "Document";

// Un devis déposé par l'agent porte sa compagnie (PER-2498) : « Devis AssurAli »,
// « Devis Allianz (Prima) » ; sans compagnie, le libellé du type (PER-2500).
const libelleDocument = (d) => libelleDevis(d, libelleDuType(d.type));

// Documents déposés sur un lead auto (graal), dans « Infos et documents » :
// les mêmes tuiles que la zone « Devis » de la carte, tous visibles, du plus
// récent au plus ancien. Le nom ouvre l'aperçu, l'icône télécharge.
const NOM_FICHIER_DER_VIERGE = "DER-vierge.pdf";

const recupererDerVierge = () =>
  Axios({ url: `${API_URL}files/public/DER_VIERGE`, method: "POST", responseType: "blob" }).then(
    (res) => new Blob([res.data], { type: "application/pdf" })
  );

const signalerDerIndisponible = () => toast.error("DER vierge indisponible, réessayez plus tard.");

const TUILE_DER_VIERGE = {
  id: "der-vierge",
  nom: "DER vierge",
  fichier: NOM_FICHIER_DER_VIERGE,
  enTete: true,
  ouvrir: () =>
    recupererDerVierge().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }).catch(signalerDerIndisponible),
  telecharger: () =>
    recupererDerVierge()
      .then((blob) => fileDownload(blob, NOM_FICHIER_DER_VIERGE))
      .catch(signalerDerIndisponible),
};

const LeadDocuments = ({ documents = [] }) => {
  const tuiles = (documents || []).map((d, index) => ({
    id: d.uuid || d.id || String(index),
    nom: libelleDocument(d),
    fichier: d.nom || (String(d.contentType || "").startsWith("image/") ? "image.jpg" : "document.pdf"),
    deposeLe: d.ajouteLe,
    ia: d.origine === "agent",
    iaLe: d.genereLe,
    compagnie: compagnieDuDocument(d),
    ouvrir: () => window.open(d.preview_url || d.url, "_blank", "noopener,noreferrer"),
    telecharger: () => window.open(d.url, "_blank", "noopener,noreferrer"),
  }));
  tuiles.push(TUILE_DER_VIERGE);

  return <DocumentsCompacts documents={tuiles} visibles={Infinity} emptyLabel="Aucun document déposé." />;
};

export default LeadDocuments;
